export { default as Img200 } from './processed/200/nature.jpg';
export { default as Img400 } from './processed/400/nature.jpg';
export { default as Img600 } from './processed/600/nature.jpg';
export { default as Imgthumb } from './processed/thumb/nature.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/nature.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/nature.jpg';
export const ImgData = { width: 1024, height: 768, ratio: 0.75, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      215,
      33,
      67
    ],
    "_population": 139,
    "_hsl": [
      0.9688644688644689,
      0.7338709677419355,
      0.48627450980392156
    ]
  },
  "LightVibrant": {
    "_rgb": [
      212,
      185,
      79
    ],
    "_population": 54,
    "_hsl": [
      0.13283208020050122,
      0.6073059360730595,
      0.5705882352941176
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      89,
      5,
      13
    ],
    "_population": 93,
    "_hsl": [
      0.9841269841269842,
      0.8936170212765958,
      0.18431372549019606
    ]
  },
  "Muted": {
    "_rgb": [
      151,
      98,
      66
    ],
    "_population": 2144,
    "_hsl": [
      0.06274509803921569,
      0.3917050691244239,
      0.4254901960784314
    ]
  },
  "LightMuted": {
    "_rgb": [
      173,
      185,
      207
    ],
    "_population": 1059,
    "_hsl": [
      0.607843137254902,
      0.2615384615384615,
      0.7450980392156863
    ]
  },
  "DarkMuted": {
    "_rgb": [
      95,
      62,
      48
    ],
    "_population": 459,
    "_hsl": [
      0.04964539007092198,
      0.3286713286713287,
      0.2803921568627451
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/nature.js